import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const businessHoursDialogStyles = StyleSheet.create({
	body: {
		// The per-day interval list can grow taller than the viewport, so scroll the body
		// while the title/footer stay pinned.
		maxHeight: '60vh',
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	checkboxLabel: {
		color: THEME.colors.text.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.sm,
	},
	checkboxRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.md,
	},
	dialogPopup: {
		maxWidth: 560,
		width: '100%',
	},
	header: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		marginTop: THEME.spacing.md,
	},
});
